import React from 'react';
import Lottie from 'react-lottie';
import breathingSparkAnimation from 'animations/Breathing_Spark_R1.json';

type BreathingSparkAnimationProps = {
  width?: React.CSSProperties['width'];
  height?: React.CSSProperties['height'];
};

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: breathingSparkAnimation,

  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};
function BreathingSparkAnimation({
  height = 50,
  width = 50,
}: BreathingSparkAnimationProps) {
  return <Lottie options={defaultOptions} height={height} width={width} />;
}

export default BreathingSparkAnimation;
